import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SetupPassword from "./pages/SetupPassword";
import ClientPortal from "./pages/client/ClientPortal";
import AnalystPortal from "./pages/analyst/AnalystPortal";
import AdminPortal from "./pages/admin/AdminPortal";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider, useToast, initializeToast } from "./components/Toast";
import {
  ConfirmProvider,
  useConfirm,
  initializeConfirm,
} from "./components/ConfirmModal";
import { useTranslation } from "react-i18next";

function PrivateRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  

  if (loading) {
    return (
      <div style={{ padding: "24px" }}>
        <div className="card">{t("common.loadingSession")}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/setup-password/:uid/:token" element={<SetupPassword />} />

      <Route
        path="/client/*"
        element={
          <PrivateRoute allowedRoles={["CLIENT"]}>
            <ClientPortal />
          </PrivateRoute>
        }
      />

      <Route
        path="/analyst/*"
        element={
          <PrivateRoute allowedRoles={["ANALYST"]}>
            <AnalystPortal />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/*"
        element={
          <PrivateRoute allowedRoles={["ADMIN"]}>
            <AdminPortal />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <AuthProvider>
          <Router>
            <InitProviders />
            <AppRoutes />
          </Router>
        </AuthProvider>
      </ConfirmProvider>
    </ToastProvider>
  );
}

// Initialize global toast and confirm instances
function InitProviders() {
  const toast = useToast();
  const confirm = useConfirm();

  useEffect(() => {
    initializeToast(toast);
    initializeConfirm(confirm);
  }, [toast, confirm]);

  return null; // This component doesn't render anything
}

export default App;
